<section class="crm">
  <header class="crm-head">
    <div>
      <p class="kicker">CRM</p>
      <h1>Leads</h1>
      <p>{{ admin() ? 'Select leads, choose the agents, and the leads are split across them.' : 'The leads assigned to you.' }}</p>
    </div>
    <div class="crm-actions">
      @if (admin()) {
        <button class="btn ghost" type="button" (click)="composer.set('agent')">New agent</button>
        <button class="btn ghost" type="button" (click)="startLead()">Add lead</button>
        <label class="btn ghost crm-file">
          Import
          <input type="file" accept=".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" (change)="importCsv($event)" />
        </label>
      }
      <div class="crm-bell-wrap">
        <button class="btn ghost crm-bell" type="button" (click)="noticesOpen.set(!noticesOpen())" [attr.aria-expanded]="noticesOpen()">
          Notifications
          @if (board.unread() > 0) {
            <strong class="crm-badge">{{ board.unread() }}</strong>
          }
        </button>
        @if (noticesOpen()) {
          <div class="crm-menu-back" (click)="noticesOpen.set(false)"></div>
          <section class="crm-notices" role="menu" aria-label="Notifications" (click)="$event.stopPropagation()">
            <h2>Notifications</h2>
            @for (item of board.items(); track item.id) {
              <button type="button" class="crm-notice-row" [class.unread]="!item.read" (click)="openNotice(item)">
                <strong>{{ item.body }}</strong>
                <span>{{ when(item.createdAt) }}</span>
              </button>
            } @empty {
              <p>No notifications yet.</p>
            }
          </section>
        }
      </div>
      <span class="crm-who">{{ auth.user()?.name }}</span>
      <button class="btn ghost" type="button" (click)="signOut()">Sign out</button>
    </div>
  </header>

  @if (failed(); as message) {
    <p class="banner" role="alert">{{ message }}</p>
  }
  @if (notice(); as message) {
    <p class="crm-notice">{{ message }}</p>
  }

  <div class="crm-filters">
    <label class="crm-search">
      Search
      <input [value]="query()" (input)="query.set($any($event.target).value)" placeholder="Name, email, country, agent" />
    </label>
    <label>
      Country
      <select [value]="countryFilter()" (change)="countryFilter.set($any($event.target).value)">
        <option value="" [selected]="countryFilter() === ''">All countries</option>
        @for (name of countries(); track name) {
          <option [value]="name" [selected]="countryFilter() === name">{{ name }}</option>
        }
      </select>
    </label>
    <label>
      Status
      <select [value]="statusFilter()" (change)="statusFilter.set($any($event.target).value)">
        <option value="" [selected]="statusFilter() === ''">All statuses</option>
        @for (item of statuses; track item) {
          <option [value]="item" [selected]="statusFilter() === item">{{ label(item) }}</option>
        }
      </select>
    </label>
    @if (admin()) {
      <label>
        Assigned to
        <select [value]="assigneeFilter()" (change)="assigneeFilter.set($any($event.target).value)">
          <option value="" [selected]="assigneeFilter() === ''">All agents</option>
          <option value="none" [selected]="assigneeFilter() === 'none'">Unassigned</option>
          @for (agent of assigneeOptions(); track agent.id) {
            <option [value]="agent.id" [selected]="assigneeFilter() === '' + agent.id">{{ agent.name }}</option>
          }
        </select>
      </label>
    }
    <p class="crm-count"><strong>{{ shown().length }}</strong> {{ shown().length === 1 ? 'lead' : 'leads' }}</p>
  </div>

  @if (composer() === 'agent') {
    <form class="crm-form" (submit)="saveAgent($event)">
      <h2>New agent</h2>
      <label>Name <input [value]="agentName()" (input)="agentName.set($any($event.target).value)" /></label>
      <label>Email <input type="email" [value]="agentEmail()" (input)="agentEmail.set($any($event.target).value)" /></label>
      <label>Phone <input [value]="agentPhone()" (input)="agentPhone.set($any($event.target).value)" /></label>
      <label>Password <input type="password" [value]="agentPassword()" (input)="agentPassword.set($any($event.target).value)" /></label>
      <div class="crm-actions">
        <button class="btn ghost" type="button" (click)="composer.set(null)">Cancel</button>
        <button class="btn primary" type="submit" [disabled]="saving()">{{ saving() ? 'Saving…' : 'Add agent' }}</button>
      </div>
    </form>
  }

  @if (composer() === 'lead') {
    <form class="crm-form" (submit)="saveLead($event)">
      <h2>New lead</h2>
      <label>First name <input [value]="firstName()" (input)="firstName.set($any($event.target).value)" /></label>
      <label>Last name <input [value]="lastName()" (input)="lastName.set($any($event.target).value)" /></label>
      <label>Email <input type="email" [value]="email()" (input)="email.set($any($event.target).value)" /></label>
      <label>Phone <input [value]="phone()" (input)="phone.set($any($event.target).value)" /></label>
      <label>Country <input [value]="country()" (input)="country.set($any($event.target).value)" /></label>
      <div class="crm-actions">
        <button class="btn ghost" type="button" (click)="composer.set(null)">Cancel</button>
        <button class="btn primary" type="submit" [disabled]="saving()">{{ saving() ? 'Saving…' : 'Save lead' }}</button>
      </div>
    </form>
  }

  @if (admin() && checked().length) {
    <form class="crm-mass" (submit)="applyMass($event)">
      <strong>{{ checked().length }} selected</strong>
      <label>
        Status
        <select [value]="massStatus()" (change)="massStatus.set($any($event.target).value)">
          <option value="">Keep status</option>
          @for (item of statuses; track item) {
            <option [value]="item">{{ label(item) }}</option>
          }
        </select>
      </label>
      <div class="crm-agent-field">
        <span>Assigned to</span>
        <div class="crm-agent-pick">
          <label class="crm-check">
            <input type="checkbox" [checked]="massUnassign()" (change)="setUnassign($any($event.target).checked)" />
            Unassigned
          </label>
          <label class="crm-check">
            <input type="checkbox" [checked]="allAgentsOn()" (change)="toggleAllAgents($any($event.target).checked)" />
            All agents
          </label>
          @for (agent of agents(); track agent.id) {
            <label class="crm-check">
              <input type="checkbox" [checked]="massAgents().includes(agent.id)" (change)="toggleMassAgent(agent.id, $any($event.target).checked)" />
              {{ agent.name }}
            </label>
          }
        </div>
      </div>
      <button class="btn primary" type="submit" [disabled]="saving() || (!massStatus() && !massUnassign() && massAgents().length === 0)">Update selected</button>
    </form>
  }

  <div class="crm-table crm-board">
    <table>
      <thead>
        <tr>
          @if (admin()) {
            <th>
              <input type="checkbox" [checked]="allShownChecked()" (change)="toggleAll($any($event.target).checked)" aria-label="Select all" />
            </th>
          }
          <th>First name</th>
          <th>Last name</th>
          <th>Online</th>
          <th>Country</th>
          <th>Status</th>
          <th>Assigned to</th>
          <th class="col-wide">Previously assigned</th>
          <th class="col-wide">Phone</th>
          <th class="col-wide">Email</th>
          @if (admin()) {
            <th></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (lead of shown(); track lead.id) {
          <tr (click)="open(lead)" [class.crm-fresh]="lead.status === 'NEW' && !lead.seen">
            @if (admin()) {
              <td (click)="keep($event)">
                <input type="checkbox" [checked]="checked().includes(lead.id)" (change)="toggle(lead.id, $any($event.target).checked)" [attr.aria-label]="'Select ' + lead.firstName" />
              </td>
            }
            <td>{{ lead.firstName }}</td>
            <td>{{ lead.lastName }}</td>
            <td><span class="crm-live" [class.on]="lead.online">{{ lead.online ? 'Online' : 'Offline' }}</span></td>
            <td>{{ lead.country || '—' }}</td>
            <td><span class="crm-status">{{ label(lead.status) }}</span></td>
            <td>{{ lead.assigneeName || 'Unassigned' }}</td>
            <td class="col-wide">{{ lead.previousAssigneeName || '—' }}</td>
            <td class="col-wide">{{ lead.phone }}</td>
            <td class="col-wide">{{ lead.email }}</td>
            @if (admin()) {
              <td (click)="keep($event)">
                <button class="crm-delete" type="button" (click)="askDelete(lead)">Delete</button>
              </td>
            }
          </tr>
        } @empty {
          <tr>
            <td [attr.colspan]="admin() ? 11 : 9">No leads match these filters.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (pendingDelete(); as person) {
    <div class="status-pop-back" role="presentation" (click)="cancelDelete()">
      <form class="status-pop" role="dialog" aria-label="Delete lead" (click)="$event.stopPropagation()" (submit)="confirmDelete($event)">
        <h2>Delete {{ person.firstName }} {{ person.lastName }}?</h2>
        <p>This removes the lead from the CRM. It cannot be undone.</p>
        <div class="status-pop-actions">
          <button class="status-cancel" type="button" (click)="cancelDelete()">Cancel</button>
          <button class="crm-delete" type="submit" [disabled]="deleting()">{{ deleting() ? 'Deleting…' : 'Delete lead' }}</button>
        </div>
      </form>
    </div>
  }
</section>
